import { actionCopyFr } from "./actionCopy";
import { listCopyFr } from "./listCopy";

export const studiesCopyFr = {
    studies: "Études",
    description:
        "Créez des études et invitez des cliniciens avec des accès, des étiquettes et une facturation déduits des modèles.",
    unauthorizedMessage: "Les études sont réservées aux administrateurs et aux gestionnaires.",
    searchPlaceholder: "Rechercher des études, étiquettes, formulaires ou modèles",
    searchAriaLabel: "Rechercher des études",
    clearSearchAria: actionCopyFr.clearSearch,
    filterStudiesAria: "Filtrer les études",
    studyFilterDescription: "Filtrez les études par statut et par formule de facturation.",
    newStudy: "Nouvelle étude",
    noStudiesYet:
        "Aucune étude pour le moment. Créez votre première étude pour configurer les accès et les invitations.",
    noStudiesMatchSearch: "Aucune étude ne correspond à votre recherche ou à vos filtres.",
    columnStudyName: "Nom de l'étude",
    columnLabel: "Étiquette",
    columnForms: "Formulaires",
    columnTemplates: "Modèles",
    columnPlan: "Formule",
    columnExpiry: "Expiration",
    columnDiaries: "Journaux",
    columnClinicians: "Cliniciens",
    columnStatus: listCopyFr.status,
    columnActions: listCopyFr.actions,
    published: listCopyFr.published,
    draft: listCopyFr.draft,
    open: actionCopyFr.open,
    invite: actionCopyFr.invite,
    edit: actionCopyFr.edit,
    openStudyAria: "Ouvrir l'étude",
    inviteStudyAria: "Inviter des cliniciens à cette étude",
    editStudyAria: "Modifier l'étude",
    openTrackingAria: "Ouvrir les graphiques de progression de l'étude",
    trackingDialogTitle: (studyName: string) => `Progression · ${studyName}`,
    emptyLabel: " - ",
    templateCount: (count: number) => `${count} modèle${count === 1 ? "" : "s"}`,
    newStudyTitle: "Nouvelle étude",
    newStudyDescription:
        "Choisissez des modèles pour déduire les accès aux événements, formulaires et calendriers, puis personnalisez les droits, la facturation et les paramètres de publication.",
    editStudyTitle: "Modifier l'étude",
    editStudyDescription:
        "Mettez à jour les modèles, les accès déduits, les droits personnalisés, la facturation et la visibilité de cette étude pour les gestionnaires.",
    studySaved: "Étude enregistrée",
    failedToSaveStudy: "Échec de l'enregistrement de l'étude",
    saveStudy: "Enregistrer l'étude",
    saveChanges: "Enregistrer les modifications",
    studyName: "Nom de l'étude",
    studyNamePlaceholder: "p. ex. Elite Tendon Knee 2026",
    labelAccess: "Accès par étiquette",
    selectLabels: "Sélectionner des étiquettes",
    addLabel: "Ajouter une étiquette",
    labelName: "Nom de l'étiquette",
    labelNamePlaceholder: "p. ex. Elite Tendon Knee",
    formAccess: "Accès aux formulaires",
    selectForms: "Sélectionner des formulaires",
    templates: "Modèles",
    inferredAccessTitle: "Accès issus des modèles",
    inferredAccessDescription:
        "Les questionnaires, calendriers et événements requis par les modèles sélectionnés sont accordés automatiquement.",
    inferredAccessEmpty: "Sélectionnez un ou plusieurs modèles pour déduire les accès des cliniciens.",
    inferredEvents: "Événements",
    inferredForms: "Questionnaires",
    inferredSchedules: "Calendriers",
    inferredNone: "Aucun",
    customiseAccessTitle: "Personnaliser les accès",
    customiseAccessHideTitle: "Masquer les options d'accès",
    customiseAccessDescription:
        "Contrôle complet des modes et des droits privés. Les questionnaires, calendriers et événements requis par les modèles restent sélectionnés.",
    loadingAccessOptions: "Chargement des options d'accès…",
    billingPlan: "Formule de facturation",
    selectPlan: "Sélectionner une formule",
    expiryDate: "Date d'expiration",
    pickDate: "JJ/MM/AAAA",
    expiryDateMinMessage: "L'expiration doit être demain ou plus tard",
    expiryDateMaxMessage: "Restons dans les 100 prochaines années",
    expiryDateInvalidMessage: "Cette date ne semble pas correcte",
    publishStudyForManagers: "Publier l'étude",
    labelAccessSummary: "Accès par étiquette",
    formAccessSummary: "Accès aux formulaires",
    templatesSummary: "Modèles",
    billingPlanSummary: "Formule de facturation",
    expirySummary: "Expiration",
    statusSummary: "Statut",
    loadingStudy: "Chargement de l'étude…",
    studyNotFound: "Étude introuvable",
    backToStudies: "Retour aux études",
    studyInvite: "Invitation à l'étude",
    inviteToStudy: (studyName: string) => `Inviter à l'étude ${studyName}`,
    inviteToStudyDescription:
        "Partagez un code QR ou un lien afin que les cliniciens puissent s'inscrire et rejoindre cette étude. Vous pouvez éventuellement imposer une organisation et une spécialité.",
    inviteStepReview: "Vérification",
    inviteStepEmail: "E-mail",
    inviteStepQr: "Code QR",
    inviteStepInvite: "Invitation",
    generatingInviteLink: "Génération du lien d'invitation…",
    failedToCreateInviteLink: "Échec de la création du lien d'invitation",
    studyInviteQrDescription: (studyName: string) =>
        `Partagez un code QR ou un lien afin que les cliniciens puissent s'inscrire et rejoindre ${studyName}. L'organisation et la spécialité proviennent des valeurs par défaut de l'étude.`,
    joinStudyTitle: (studyName: string) => `Rejoindre ${studyName}`,
    optionalOrganisationSignupHint:
        "Facultatif. Laissez vide pour que le clinicien crée sa propre organisation lors de l'intégration.",
    clinicianWillChooseOrganisation: "Le clinicien choisira ou créera son organisation lors de l'inscription.",
    specialty: "Spécialité",
    optionalSuffix: "(facultatif)",
    optionalSpecialtySignupHint:
        "Facultatif. Si elle est définie, la spécialité est appliquée aux cliniciens qui rejoignent cette étude.",
    selectSpecialtyPlaceholder: "Sélectionner une spécialité",
    clearSpecialty: "Effacer",
    clinicianInviteDefaultsTitle: "Valeurs par défaut de l'invitation des cliniciens",
    clinicianInviteDefaultsDescription:
        "Vous pouvez imposer une organisation et une spécialité aux cliniciens qui rejoignent cette étude via un code QR ou un lien d'invitation.",
    defaultOrganisation: "Organisation",
    noOrganisationsAvailable: "Aucune organisation disponible à sélectionner.",
    inviteDefaultsSummary: (summary: string) => `Valeurs par défaut de l'invitation : ${summary}`,
    inviteDefaultsEmpty:
        "Aucune organisation ni spécialité imposée pour cette étude. Les cliniciens les renseignent lors de l'intégration.",
    emailRequired: "L'adresse e-mail est obligatoire",
    validEmailRequired: "Saisissez une adresse e-mail valide",
    studyInviteEmailSent: "E-mail d'invitation à l'étude envoyé",
    failedToSendInvite: "Échec de l'envoi de l'invitation",
    trackingTitle: "Suivi de l'étude",
    trackingDescription: "Les cliniciens disposant des étiquettes de cette étude et les journaux qu'ils ont créés.",
    trackingLabelsHint: "Étiquettes",
    trackingLoading: "Chargement du suivi…",
    trackingError: "Impossible de charger le suivi de l'étude.",
    trackingNoLabels: "Ajoutez des étiquettes à cette étude pour suivre les cliniciens et les journaux.",
    trackingNoClinicians: "Aucun clinicien ne possède encore ces étiquettes.",
    trackingNoDiaries: "Aucun journal n'a encore été étiqueté pour cette étude.",
    trackingCliniciansWithAccess: "Cliniciens ayant accès",
    trackingCliniciansHint: (members: number, withLabels: number) =>
        `${members} membre${members === 1 ? "" : "s"} de l'étude · ${withLabels} avec accès par étiquette`,
    trackingTotalDiaries: "Journaux",
    trackingAvgDiariesPerClinician: "Moy. journaux / clinicien",
    trackingCliniciansWithDiaries: "Cliniciens avec journaux",
    trackingDiariesPerClinician: "Journaux par clinicien",
    trackingCumulativeDiaries: "Journaux cumulés",
    trackingClinicianTableTitle: "Cliniciens",
    trackingColumnClinician: "Clinicien",
    trackingColumnDiaries: "Journaux",
    trackingColumnAccess: "Accès",
    trackingAccessMember: "Membre de l'étude",
    trackingAccessLabel: "Accès par étiquette",
    trackingAccessDiaryOnly: "Journaux uniquement",
    trackingCliniciansShort: "cliniciens",
    trackingNoLabelsShort: "Aucune étiquette",
    trackingNoDiariesShort: "Aucun journal pour le moment",
};
